export enum CreationType {
	FEDERATED = 'federated',
	LOCAL = 'local',
}
